// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import donate from './routes/donate';
import templateCustom from './routes/templatecustom';
import templateSidebar from './routes/templatesidebar';
import ambassadors from './routes/ambassadors';
import latestnews from './routes/latestnews';
import blog from './routes/blog';
import category from './routes/category';
import search from './routes/search';
import findUs from './routes/findUs';
import mediaCentre from './routes/mediaCentre';
import vet from './routes/vet';
import templateAnimals from './routes/templateAnimals';
import meetTheTeam from './routes/meetTheTeam';
import templateSingleAnimal from './routes/templateSingleAnimal';
import templatePetitions from './routes/templatePetitions';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  category,
  // About Us page, note the change from about-us to aboutUs.
  donate,
  vet,
  templateCustom,
  templateSidebar,
  ambassadors,
  blog,
  latestnews,
  findUs,
  templateAnimals,
  templateSingleAnimal,
  meetTheTeam,
  search,
  mediaCentre,
  templatePetitions
});

// Load Events
jQuery(document).ready(
  () => init()
);

jQuery(window).scroll(() =>  {
    var scroll = $(window).scrollTop();

    if (scroll >= 150)
    {
        jQuery("#backtop").show();
    } else {
        jQuery("#backtop").hide();
    }

    if (scroll >= 100) {
        jQuery('.banner').addClass("sticky");
    } else {
        jQuery('.banner').removeClass("sticky");
    }
});

function init()
{
    routes.loadEvents();

    $(".cruelty").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#reportCruelty").offset().top - 140
        }, 2000);
    });

    /*$([document.documentElement, document.body]).animate({
        scrollTop: $("#contentBlock .tabcontent.active").offset().top - 140
    }, 2000); */ 
          
    $('#backtop').click(function() {
        $('body,html').animate({scrollTop:0},800);
    });   
    
    jQuery('.homedropdown').select2({
        minimumResultsForSearch: Infinity,
        containerCssClass : "customdropdown",
        placeholder: "Select a Location"
    });

    jQuery(document).on('click', '.wpcf7-radio .wpcf7-list-item', function(e){
        e.stopPropagation();
        if (jQuery( "input", jQuery( e.currentTarget ) ).prop("checked"))
        {
            jQuery( "input", jQuery( e.currentTarget ) ).prop("checked", false);
        } else {
            jQuery( "input", jQuery( e.currentTarget ) ).prop("checked", true);
        }
    });

    
    jQuery(document).on('click', '.wpcf7-checkbox .wpcf7-list-item', function(e){
        e.stopPropagation();
        
        if (jQuery( "input", $( e.currentTarget ) ).prop("checked"))
        {
            jQuery( "input", $( e.currentTarget ) ).prop("checked", false);
        } else {
            jQuery( "input", $( e.currentTarget ) ).prop("checked", true);
        }
    });


    jQuery("#mobilemenu").click(e => {
        e.stopPropagation();

        if (jQuery("#mobilemenu i").hasClass("fa-times"))
        {
            jQuery(".banner").removeClass("mobile");
            jQuery("#mobilemenu i").addClass("fa-bars");
            jQuery("#mobilemenu i").removeClass("fa-times");
            jQuery("#mobilenav").removeClass("activated");
            jQuery("body").removeClass("mobnav");
            jQuery("#mobilenav").removeClass("sticky");
        } else {
            if (jQuery(".banner").hasClass("sticky"))
            {
                jQuery("#mobilenav").addClass("sticky");
            }
            jQuery(".banner").addClass("mobile");
            jQuery("#mobilenav").addClass("activated");
            jQuery("#mobilemenu i").removeClass("fa-bars");
            jQuery("#mobilemenu i").addClass("fa-times");
            jQuery("body").addClass("mobnav");
        }
        
        
    });

    $('#mobilenav .navz .is-parent > a').on('click', function() { 
        
        if (jQuery( this ).parent().hasClass('menucollapse'))
        {
            jQuery( this ).parent().removeClass("menucollapse");
            jQuery( "i", this ).removeClass('fa-angle-up');
            jQuery( "i", this ).addClass('fa-angle-down');  
            
            return false;
        } else {
            jQuery( this ).parent().addClass("menucollapse");
            jQuery( "i", this ).removeClass('fa-angle-down');
            jQuery( "i", this ).addClass('fa-angle-up');
            
            return false;
        }
    });


    let $j = jQuery.noConflict();

    let $jcontent = $j('#whatwedo');

    function numberWithCommas(number) {
        var parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    $jcontent.waypoint(function (){
        $('.count').each(function () {
            $(this).prop('Counter',0).animate({
                Counter: $(this).text(),
            }, {
                duration: 3500,
                easing: 'swing',
                step: function (now) {
                    $(this).text(numberWithCommas(Math.ceil(now)));
                },
            });
        });
        this.destroy();
    }, {offset: 900});

    


}

$(window).load(function() {

    let height = ($('.helpslidecontainer').height() > 450) ? 450 : $('.helpslidecontainer').height(); 
    $('.equalHeight').height(height);

    $(window).resize(function()
    {
        let width = jQuery(window).width();

        if (width <= 767)
        {
            return;
        }

        if ($('.equalHeight').height() != $('.helpslidecontainer').height())
        {
            let height = ($('.helpslidecontainer').height() > 450) ? 450 : $('.helpslidecontainer').height(); 
            $('.equalHeight').height(height);
        }
        
    });
});

function calcSignaturesPercentage() {
    var total = +jQuery('#total').data('total');
    var goal = +jQuery('#percentage').data('goal');
    var percentage = (total / goal) * 100;

    jQuery('#percentage').css("width", percentage + "%");
}

jQuery(document).ready(function() {
    jQuery(".backup_picture").on("error", function(){
        jQuery(this).attr('src', 'https://www.awlnsw.com.au/wp-content/themes/animalleague/resources/assets/images/No-image-available-1024x1024.jpg');
    });

    if(jQuery(".have-signed").length) {
        calcSignaturesPercentage()
    }
});



// WEBPACK FOOTER //
// ./scripts/main.js